import { FC } from 'react';
import { PlaygroundSvgIconProps } from '@utmb/features/races/races-list/playgrounds/PlaygroundIcon';

const GlacierIcon: FC<PlaygroundSvgIconProps> = ({ color }) => {
    return (
        <>
            <style jsx>{`
                .cls-1 {
                    fill: none;
                    stroke: ${color};
                    stroke-miterlimit: 10;
                    stroke-width: 2px;
                }
            `}</style>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.54 30.67" width="34" height="34">
                <polyline className="cls-1" points="13.71 27.81 25.04 8.93 27.98 8.93 31.88 1.53 43.68 10.81 52.65 28.44" />
                <polyline className="cls-1" points="5.63 16 11.65 7.82 21.33 16" />
                <line className="cls-1" x1="29.69" y1="22.17" x2="22.64" y2="12.92" />
                <line className="cls-1" x1="45.1" y1="13.6" x2="33.18" y2="30.08" />
                <line className="cls-1" x1="0.8" y1="22.54" x2="6.46" y2="14.99" />
                <polyline className="cls-1" points="12.92 8.89 19.6 1.57 27.98 7.82" />
                <line className="cls-1" x1="46.77" y1="30.08" x2="40.92" y2="18.88" />
            </svg>
        </>
    );
};

export default GlacierIcon;
